import React, { useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import { 
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogActions,
    LinearProgress,
    Link,
    TextField,
    Typography
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

import {supportTheme} from '../../../theme';
import {
    DialogTextField,
    DialogFooter
} from './SupportDialogStyles';


export default function SupportDialogSuccess(props){
    const { formState, setFormState, handleSubmit, handleClose, ticketKey, ticketURL, handleReturnToStart, warnings } = props
    const t = supportTheme


    return (
        <React.Fragment>
            <DialogContent sx={{ 
                color: 'rgb(175, 175, 175)', 
                padding: t.size.panelInset, 
                pt: 10,
                gap: 2, 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                overflow: 'hidden',
            }}>

                <Box
                    sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: '60px',
                        width: '60px',
                        borderRadius: '50%',
                        backgroundColor: 'rgb(45, 55, 45)',
                        border: '1px solid rgb(72, 94, 72)',
                    }}
                >

                <DoneIcon
                    sx={{
                    position: "absolute",
                    fontSize: 40,
                    color: "rgb(175, 255, 175)",
                    }}
                />
                </Box>



                <Typography sx={{...t.type.title}}>Request submitted</Typography>
                <Typography sx={{...t.type.body}}>Your ticket has been created in Jira Service Management</Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        border: '1px solid rgb(72, 94, 72)',
                        borderRadius: "10px",
                        padding: 2,
                        backgroundColor: 'rgb(25, 31, 25)',
                    }}>
                    <Typography sx={{...t.type.contextLabel}}>Reference</Typography>
                    <Typography sx={{...t.type.ticketKey}}>{ticketKey}</Typography>
                </Box>



                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>          
                <Typography sx={{...t.type.body, mt: 2}}>You will receive an email with confirmation at</Typography>
                <Typography sx={{...t.type.body}}>{formState.userEmail}</Typography>
                </Box>


                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>          
                    <Typography sx={{...t.type.body, mt: 2}}>Manage your ticket at the following URL:</Typography>
                    <Link href={ticketURL} sx={{...t.type.hyperlink, mt: 0}} target="_blank" rel="noopener">Ticket {ticketKey}</Link>
                </Box>


                {warnings && warnings.length > 0 && (
                    <Box sx={{
                        width: '80%', 
                        maxHeight: '200px',
                        border: `1px solid ${t.color.errorBorder}`, 
                        borderRadius: t.radius.control,
                        p: 1, 
                        mt: 2,
                        overflowY: 'scroll',
                    }}>
                        <Typography variant='overline'>Warning{warnings.length > 1 ? 's' : ''}</Typography>
                        <br></br>
                                                {warnings.map((warning, index) => {
                            if (warning === 'attachment') {
                                warning = 'An error occurred while trying to upload attachments. Please try uploading your attachments via your ticket management page linked above.';
                            }
                            return <Typography key={index} sx={{...t.type.body}}>{warning}</Typography>
                        })}

                    </Box>




                )}


            </DialogContent>

            <DialogFooter>
                <DialogActions>
                    <Button 
                        onClick={handleReturnToStart} 
                        sx={t.component.secondaryButton}
                    >
                        Submit another
                    </Button>
                    <Button
                        onClick={handleClose}
                        sx={t.component.primaryButton}
                    >
                        Close
                    </Button>       
                </DialogActions>
            </DialogFooter>

        </React.Fragment>
    )
}